import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { AuthShell, authInput } from "@/pages/ForgotPassword";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return setError("Les deux mots de passe ne correspondent pas");
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token: params.get("token") || "", password: pwd });
      toast.success(data.message);
      navigate("/login");
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell>
      <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Nouveau mot de passe</h1>
      <p className="text-slate-500 font-medium mt-1 text-sm">Choisissez un mot de passe d'au moins 6 caractères.</p>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <div>
          <label className="text-sm font-semibold text-slate-700">Nouveau mot de passe</label>
          <input data-testid="reset-password" type="password" required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)} className={authInput} />
        </div>
        <div>
          <label className="text-sm font-semibold text-slate-700">Confirmez</label>
          <input data-testid="reset-password-confirm" type="password" required minLength={6} value={pwd2} onChange={(e) => setPwd2(e.target.value)} className={authInput} />
        </div>
        {error && <div data-testid="reset-error" className="text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
        <button data-testid="reset-submit" disabled={loading} className="w-full h-11 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors duration-200 disabled:opacity-60">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enregistrer"}
        </button>
      </form>
    </AuthShell>
  );
}
